import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { UserContext } from "../Authcontext";
import { API_BASE_URL } from "../api_config";
import { Link } from "react-router-dom";
import { FaHeart, FaUser, FaCalendarAlt } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";

export default function Inbox() {
  const { user, token } = useContext(UserContext);
  const [otherlikedUsers, setOtherLikedUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.other_liked) {
      setLoading(true);
      const otherInterestsArray = user.other_liked.split(",").map(Number);
      axios
        .post(
          `${API_BASE_URL}/api/get-user-by-other-liked`,
          { otherInterestsArray },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        )
        .then((response) => {
          if (Array.isArray(response.data)) {
            setOtherLikedUsers(response.data);
          }
          setLoading(false);
        })
        .catch((error) => {
          // Handle error if needed
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [user, token]);

  if (loading) {
    return <div className="modern-loading">Loading your admirers...</div>;
  }

  return (
    <div className="modern-mailbox-messages">
      {otherlikedUsers.length === 0 ? (
        <div className="modern-empty-state">
          <div className="empty-icon"><FaHeart /></div>
          <h3>No Admirers Yet</h3>
          <p>When someone likes your profile, they will appear here</p>
        </div>
      ) : (
        <ul className="modern-message-list">
          {otherlikedUsers.map((profile, i) => (
            <li className="modern-message-item" key={i}>
              <div className="modern-message-avatar">
                {profile.filename ? (
                  <img 
                    src={`${API_BASE_URL}/uploads/${profile.filename}`} 
                    alt={profile.first_name} 
                  />
                ) : (
                  <CgProfile className="default-avatar" />
                )}
              </div>
              <div className="modern-message-content">
                <div className="modern-message-header">
                  <h4 className="modern-message-name">{profile.first_name} {profile.last_name}</h4>
                  <span className="modern-message-action">
                    <FaHeart className="heart-icon" /> Liked your profile
                  </span>
                </div>
                <div className="modern-message-details">
                  <div className="modern-message-detail">
                    <FaUser className="detail-icon" />
                    <span>{profile.age} years</span>
                  </div>
                  {profile.city_name && (
                    <div className="modern-message-detail">
                      <FaCalendarAlt className="detail-icon" />
                      <span>{profile.city_name}, {profile.state_name}</span>
                    </div>
                  )}
                </div>
                <Link
                  to={"/view-profile"}
                  state={{ userId: profile.user_id }}
                  className="modern-message-button"
                >
                  View Profile
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
